import {jsonFetch} from "../api/JsonFetch";

let Company = {
    /**
     *
     */
    getOne: async (id) => {
        let url = '/admin/company/' + id;

        const response = await jsonFetch('GET', url);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    getAll: async (payload) => {
        let url = '/admin/companies';

        const response = await jsonFetch('POST', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    create: async (payload) => {
        let url = '/admin/company';

        const response = await jsonFetch('POST', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    update: async (id, payload) => {
        let url = '/admin/company/' + id;

        const response = await jsonFetch('PUT', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    delete: async (id) => {
        let url = '/admin/company/' + id;

        const response = await jsonFetch('DELETE', url);
        if (response.ok) {
            return null;
        }

        throw Error(response.statusText);
    },
}

export {Company};